import { render, staticRenderFns } from "./AdminProfileModal.vue?vue&type=template&id=3bd436c2&scoped=true"
import script from "./AdminProfileModal.vue?vue&type=script&lang=js"
export * from "./AdminProfileModal.vue?vue&type=script&lang=js"
import style0 from "./AdminProfileModal.vue?vue&type=style&index=0&id=3bd436c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd436c2",
  null
  
)

export default component.exports